// Local builds use the source baseline; deployment builds inject one reserved version.
import { version } from '../../package.json';

export const APPLICATION_VERSION = typeof __BAYESPREP_APP_VERSION__ === 'string'
  ? __BAYESPREP_APP_VERSION__ : version;
